export const actionTypes = {
  USER_STATUS: 'USER_STATUS',
  USER_STATUS_OK: 'USER_STATUS_OK',
  USER_STATUS_KO: 'USER_STATUS_KO',
};

export const getStatus = payload => ({
  type: actionTypes.USER_STATUS,
  payload: payload
});
